module.exports = __webpack_public_path__ + "img/wheat-awn-slash.7adf81bb.svg";